import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@jti/ui/components/Icon";
import { setLanguageCookie } from "@jti/ui/components/LanguageSelector";
import ArrowRight from "@jti/ui/icons/arrow-right.svg";
import "./NavigationStoreSelector.scss";
const rootClassName = "aem-navigationStoreSelector";
export const NavigationStoreSelectorLink = ({ title, path, relatedLanguage }) => {
    const selectLocation = (path, selectedLanguage) => {
        setLanguageCookie(selectedLanguage);
        window.location.assign(path);
    };
    return (_jsxs("li", { className: `${rootClassName}__link`, tabIndex: 0, role: "link", "data-testid": "navigation-store-selector-link", onClick: () => selectLocation(path, relatedLanguage), onKeyDown: (e) => e.key === "Enter" && selectLocation(path, relatedLanguage), children: [_jsx("strong", { className: `${rootClassName}__link-title`, children: title }), _jsx("span", { className: `${rootClassName}__icon`, children: _jsx(Icon, { component: ArrowRight, width: "28px", height: "13px" }) })] }));
};
//# sourceMappingURL=NavigationStoreSelectorLink.js.map